import React, {Component} from 'react';

export default class ImageViewer extends Component {
  render() {
    const {value, classes, editMode} = this.props;

    return (
      <img className={classes + '-img'} src={value ? value : '/user-blank.png'} onClick={editMode}/>
    );
  }
}



// WEBPACK FOOTER //
// ./client/pages/persona/imageField/ImageViewer.jsx